import React, { useMemo } from "react";
import PropTypes from "prop-types";
import { Chip, Stack } from "@mui/material";
import {
  buildMappingTokenChipItems,
} from "./utils/mappingTokenCategoryUtils";

export {
  buildMappingTokenChipItems,
  collectActiveMappingTokens,
  resolveMappingTokenChipState,
  CATEGORY_LEVEL_TOKENS,
  CATEGORY_PATH_EXCLUSIVE_TOKENS,
} from "./utils/mappingTokenCategoryUtils";

const CHIP_STATE_CLASS = {
  active: "is-active",
  inactive: "is-inactive",
  suppressed: "is-suppressed",
};

const MappingTokenStatusBar = ({
  fieldKeys = [],
  mapping = {},
  columnDefaultRules = {},
}) => {
  const items = useMemo(
    () => buildMappingTokenChipItems(fieldKeys, mapping, columnDefaultRules),
    [fieldKeys, mapping, columnDefaultRules],
  );

  if (!items.length) {
    return null;
  }

  return (
    <Stack
      direction="row"
      flexWrap="wrap"
      useFlexGap
      spacing={0.5}
      className="cm-mapping-token-bar"
      role="list"
      aria-label="Stato token mapping"
    >
      {items.map(({ token, state }) => (
        <Chip
          key={token}
          label={token}
          size="small"
          variant="outlined"
          className={`cm-mapping-token-chip ${CHIP_STATE_CLASS[state] || ""}`.trim()}
          role="listitem"
        />
      ))}
    </Stack>
  );
};

MappingTokenStatusBar.propTypes = {
  fieldKeys: PropTypes.arrayOf(PropTypes.string),
  mapping: PropTypes.object,
  columnDefaultRules: PropTypes.object,
};

export default MappingTokenStatusBar;
